import axios from "axios";
import { FRONTEND_ROUTES } from "@fysaro/shared";
import { useAuthStore } from "@/app/store/auth.store";
import { supabase } from "@/shared/lib/supabase";
import i18n from "@/i18n/config";

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL ?? "http://localhost:4000/api",
  withCredentials: true,
});

api.interceptors.request.use(async (config) => {
  const {
    data: { session },
  } = await supabase.auth.getSession();

  // Obtenemos la clínica activa de tu store de Zustand
  const activeClinicId = useAuthStore.getState().activeClinicId;
  const language = i18n.resolvedLanguage || i18n.language;

  if (language) {
    if (config.params instanceof URLSearchParams) {
      if (!config.params.has("language")) config.params.set("language", language);
    } else {
      const params = { ...(config.params ?? {}) };
      if (!params.language) {
        params.language = language;
      }
      config.params = params;
    }
  }

  if (session?.access_token) {
    config.headers.Authorization = `Bearer ${session.access_token}`;

    // 🚀 ENVIAMOS LA CLÍNICA ACTIVA EN CADA PETICIÓN
    if (activeClinicId) {
      config.headers["x-clinic-id"] = activeClinicId;
    }
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (
      error.response?.data instanceof Blob &&
      error.response.data.type === "application/json"
    ) {
      // Convertimos el blob a texto para ver el error real
      const text = await error.response.data.text();
      error.response.data = JSON.parse(text);
    }

    if (error.response?.status === 401) {
      const { logout, user } = useAuthStore.getState();

      const role = user?.role;

      logout();
      
      const redirect =
        role === "PATIENT"
          ? FRONTEND_ROUTES.auth.loginPatient
          : FRONTEND_ROUTES.auth.loginClinic;

        window.location.href = redirect;
    }
    return Promise.reject(error);
  },
);
